/* eslint-disable import/no-unused-modules */

import rootStoreInstance from "../../stores/rootStoreInstance";
import withProvider from "../../utilities/withProvider";
import SellerInquiry from "./SellerInquiry";

const ConnectedSellerInquiry = withProvider(rootStoreInstance)(SellerInquiry);

export { ConnectedSellerInquiry as default };
